<app-page-header
  eyebrow="Класация"
  title="Градове"
  [lead]="leadText()"
/>

<app-market-notice />

<div class="filters-bar">
  <div class="filter-tabs" role="tablist">
    <button
      type="button"
      class="tab-btn"
      [class.active]="filterType() === 'all'"
      (click)="filterType.set('all')"
    >
      Всички ({{ totalCount() }})
    </button>
    <button
      type="button"
      class="tab-btn"
      [class.active]="filterType() === 'district'"
      (click)="filterType.set('district')"
    >
      Областни градове ({{ districtCount() }})
    </button>
    @if (otherCount() > 0) {
      <button
        type="button"
        class="tab-btn"
        [class.active]="filterType() === 'other'"
        (click)="filterType.set('other')"
      >
        Други градове ({{ otherCount() }})
      </button>
    }
  </div>
  <div class="search-box">
    <input
      type="search"
      placeholder="Търсене на град..."
      [value]="searchQuery()"
      (input)="searchQuery.set($any($event.target).value)"
    />
  </div>
</div>

@if (cities(); as list) {
  @if (list.length === 0) {
    <p class="empty-state">Няма намерени градове по зададения критерий.</p>
  } @else {
    <div class="table-wrap">
    <table class="data-table">
      <thead>
        <tr>
          <th>Град</th>
          <th class="num sortable" (click)="sortBy('price')" [class.on]="sort() === 'price'">Офертна €/м²</th>
          <th class="num sortable" (click)="sortBy('yoy')" [class.on]="sort() === 'yoy'">ГоГ</th>
          <th class="num sortable" (click)="sortBy('qoq')" [class.on]="sort() === 'qoq'">КоК</th>
          <th class="num sortable" (click)="sortBy('dom')" [class.on]="sort() === 'dom'">DOM</th>
          <th class="num sortable" (click)="sortBy('tx')" [class.on]="sort() === 'tx'">Сделки ГоГ</th>
          <th class="num sortable" (click)="sortBy('yield')" [class.on]="sort() === 'yield'">Доходност</th>
          <th class="num sortable" (click)="sortBy('inventory')" [class.on]="sort() === 'inventory'">Обяви</th>
          <th class="num sortable" (click)="sortBy('overheating')" [class.on]="sort() === 'overheating'">Прегряване</th>
          <th>12 месеца</th>
        </tr>
      </thead>
      <tbody>
        @for (c of list; track c.city.id) {
          <tr>
            <td>
              <a class="city-link" [routerLink]="['/grad', c.city.slug]">{{ c.city.name }}</a>
            </td>
            <td class="num strong">{{ c.medianEurPerM2 | eurM2 }}</td>
            <td class="num"><app-delta-chip [value]="c.yoyPct" label="ГоГ" /></td>
            <td class="num muted">{{ c.qoqPct | pct }}</td>
            <td class="num muted">{{ c.domDays | bgInt }} дни</td>
            <td class="num"><app-delta-chip [value]="c.transactionsYoYPct" label="ГоГ" /></td>
            <td class="num">{{ c.rentalYieldPct | bg2 }} %</td>
            <td class="num">{{ c.activeListings | bgInt }}</td>
            <td class="num">
              <span
                class="heat"
                [class.hot]="(c.overheatingScore ?? 50) > 65"
                [class.cool]="(c.overheatingScore ?? 50) < 40"
              >
                {{ c.overheatingScore ?? '—' }}
              </span>
            </td>
            <td class="spark-cell"><app-sparkline [series]="c.sparkline" /></td>
          </tr>
        }
      </tbody>
    </table>
  </div>
  }
} @else {
  <p class="loading">Зареждане…</p>
}
